export enum B2bPartnershipType {
  FULLY_COVERED = 'Fully Covered',
  NON_CONFORMING = 'Non-Conforming',
  NOT_SPECIFIED = 'Not Specified',
  NONE = 'None',
}

export enum B2bPartnerChannelType {
  NOT_SPECIFIED = 'Not Specified',
  MEDICAL_REFERRAL = 'Medical Referral',
  CHANNEL_PARTNER = 'Channel Partner',
  MARKETING_PARTNER = 'Marketing Partner',
  BUSINESS_CONTRACT = 'Business Contract',
}
